import 'highlight.js/styles/obsidian.css'
import hljs from 'highlight.js/lib/core'
import hljsVuePlugin from '@highlightjs/vue-plugin'

// import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'

export default defineNuxtPlugin((nuxtApp) => {
	// hljs.registerLanguage('javascript', javascript)
	hljs.registerLanguage('json', json)

	nuxtApp.vueApp.use(hljsVuePlugin)
})